import { useQuery } from '@tanstack/react-query';

import apiClient from '../apiClient';
import { CategoryRes } from '@/types/category';
import { useInfiniteQuery } from '@tanstack/react-query';


export const useGetAllCategory = ({
  search,
  parentId,
  all = false,
}: {
  search?: string;
  parentId?: string;
  all?: boolean;
}) => {
  return useQuery<CategoryRes>(['GetTags'], async () => {
    return await apiClient
      .get('tags', {
        params: {
          parentTagId: parentId ? parentId : null,
          all,
          search,
        },
      })
      .then((res) => res.data);
  });
};



export const useGetAllCategoryInfinite = ({
  search,
  parentId,
  all = false,
}: {
  search?: string;
  parentId?: string;
  all?: boolean;
}) => {
  return useInfiniteQuery(
    ['GetTags', { search, parentId }],
    async ({ pageParam = 1 }) => {
      const response = await apiClient.get('tags', {
        params: {
          parentTagId: parentId || null,
          all,
          search,
          page: pageParam,
          pageSize: 10,
        },
      });
      return response.data;
    },
    {
      getNextPageParam: (lastPage) => {
        const { pagination } = lastPage;
        return pagination.page < pagination.pageCount
          ? pagination.page + 1
          : undefined;
      },
    },
  );
};
